// extracted by mini-css-extract-plugin
module.exports = {"scroll-black":"IconButton_scroll-black__IR9I1","button_circle":"IconButton_button_circle__uoDMV","indicator":"IconButton_indicator__2PGi8"};